const DEFAULT_CANONICAL_ORIGIN = 'https://paradise-performance.com';

const normalizePathname = (pathname) => {
  if (!pathname) return '/';
  const withLeadingSlash = pathname.startsWith('/') ? pathname : `/${pathname}`;
  if (withLeadingSlash === '/') return '/';
  return withLeadingSlash.replace(/\/+$/, '');
};

export const canonicalizeUrl = (input, origin = DEFAULT_CANONICAL_ORIGIN) => {
  if (typeof input === 'string' && input.trim()) {
    if (/^https?:\/\//i.test(input)) {
      try {
        const u = new URL(input);
        return `${origin}${normalizePathname(u.pathname)}`;
      } catch (_) {
        return `${origin}${normalizePathname('/')}`;
      }
    }

    return `${origin}${normalizePathname(input)}`;
  }

  return `${origin}/`;
};

export const canonicalFromLocation = (origin = DEFAULT_CANONICAL_ORIGIN) => {
  if (typeof window === 'undefined' || !window.location) return `${origin}/`;
  return canonicalizeUrl(window.location.pathname, origin);
};
